export default "__VITE_ASSET__D2X25gq5__"